const AM = {
  /**
   * Check if the window is at a specific breakpoint
   * "bp": Number (768)
   */
  checkIfBelowBreakpoint(bp = 768) {
    if (window.matchMedia(`(min-width: ${bp}px)`).matches) {
      return false;
    } else {
      return true;
    }
  },

  /**
   * Create or destroy a swiper instance
   * depending on a breakpoint.
   * "bp": Number (768)
   * "target": DOM Element - containing Swiper
   * "options": Object - options for the swiper
   */
  handleSwiperBreakpoint(bp, target, options = {}) {
    if (this.checkIfBelowBreakpoint(bp)) {
      if (target.swiper == null) {
        const swiper = new Swiper(target, { ...options });
        swiper.init();
      }
    } else if (target.swiper != null) {
      target.swiper.destroy();
    }
  },

  /**
   * Update line item quantity in cart
   * "line": Number (1)
   * "qty": Number (5)
   */
  updateQuantity(line, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: qty, line: line }),
    })
      .then((res) => res.json())
      .then(() => {
        window.dispatchEvent(new Event("cart-updated"));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },

  /**
   * Format currency to locale
   * "money": Number (3500)
   * "tax": Number (1.2)
   * "countryCode": String (en-GB)
   * "currency": String (GBP)
   */
  formatCurrency(money, tax, countryCode, currency) {
    return new Intl.NumberFormat(countryCode, {
      style: "currency",
      currencyDisplay: "narrowSymbol",
      currency,
    }).format((money * tax) / 100);
  },

  /**
   * Fetch information about the cart
   */
  async fetchCart() {
    return fetch("/cart.js")
      .then((res) => res.json())
      .then((res) => res)
      .catch((error) => {
        console.error("Error:", error);
      });
  },

  /**
   * Add the form content to the cart
   */
  addToCart(formData, callback) {
    let headers = {};
    if (typeof formData === "string") {
      headers = {
        "Content-Type": "application/json",
      };
    }

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers,
    })
      .then((res) => {
        return res.json();
      })
      .then(() => {
        callback?.();
        this.updateHeaderCartItems();
        window.dispatchEvent(new Event("cart-updated"));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },

  /**
   * Update cart total in header
   * "newItems": Number (3)
   */
  updateHeaderCartItems() {
    const cartTotal = document.querySelector(
      ".header__navigation__cart-quantity"
    );
    this.fetchCart().then((res) => {
      cartTotal.innerHTML = res.item_count;
      setTimeout(function () {
        cartTotal.classList.remove("hide");
        cartTotal.classList.add("show");
      }, 500);
    });
  },

  /**
   * Animate in each block
   */
  setDefaultPositions(element) {
    element.classList.add("animated-in");
    gsap.to(element, { autoAlpha: 0, translateY: "8rem" });
  },
  animateBlockIn(element) {
    gsap.to(element, { autoAlpha: 1, translateY: 0, duration: 1 });
  },
  animateBlockOut(element) {
    gsap.to(element, { autoAlpha: 0, duration: 1 });
  },

  /**
   * Return product name from accronym
   */
  productNameFromAccr(accr) {
    return productAcronyms[accr];
  },

  /**
   * Return the current template
   */
  getCurrentTemplate() {
    return document.querySelector("body").dataset.template;
  },
};

/**
 * A list containing finish acronyms and their translations
 */

const productAcronyms = {
  ABL: "antique brass lacquered",
  ABUL: "antique brass unlacquered",
  AC: "antique copper",
  ACP: "antique copper plate",
  ACL: "antique copper lacquered",
  ASL: "antique silver lacquered",
  AMB: "american bronze lacquered",
  ANT: "antique brass unlacquered",
  Antique: "antique",
  AntiqueLacquered: "antique lacquered",
  AS: "antique silver",
  ASP: "antique silver plate",
  Barrelled: "barrelled",
  BEL: "aged brass",
  Black: "blacknickel",
  BMA: "bronze metal antique",
  Bright: "brightnickel",
  Bronze: "bronze",
  CBP: "chocolate bronze plate",
  Chrome: "chrome",
  COP: "copper plate",
  Gilt: "gilt",
  HBB: "hand burnished brass",
  HBN: "hand burnished nickel",
  MBL: "matt black lacquered",
  MWL: "matt white lacquered",
  NBP: "aged nickel",
  Nickel: "nickel",
  PBL: "polished brass lacquered",
  PBUL: "polished brass unlacquered",
  PC: "polished chrome",
  PCP: "polished chrome plate",
  PN: "polished nickel",
  PNP: "polished nickel plate",
  POL: "polished brass lacquered",
  SAL: "satin antique gloss lacquered",
  SAS: "satin antique satin lacquered",
  SAT: "satin brass lacquered",
  SBL: "satin brass lacquered",
  SBSL: "satin brass satin lacquered",
  SBUL: "satin brass unlacquered",
  SC: "satin chrome",
  SCL: "satin copper satin lacquered",
  SCP: "satin chrome plate",
  SN: "satin nickel",
  SNP: "satin nickel plate",
  Stainlesssteel: "stainless steel",
  AGC: "aged copper",
  DAB: "dark aged brass",
  DBZ: "dark bronze",
  FEA: "fine English antique",
  SAUL: "satin antique unlacquered",
};

/**
 * Toggles (modals, menus, etc...
 * ... things that should be toggled globally)
 */
function handleToggles() {
  return {
    toggles: {
      skrim: false,
      finishModalOpen: false,
      orderASampleModalOpen: false,
      finishChipsModalOpen: false,
      menuOpen: false,
      brochureModal: false,
      enquiryModal: false,
      grillesOrderForm: false,
      finishesModal: false,
      readyToShipFilters: false,
      blogFilters: false,
      searchOpen: false,
      productEnquiryModal: false,
    },

    closeAllToggles() {
      const allToggles = Object.keys(this.toggles);
      allToggles.forEach((toggle) => {
        this.toggles[toggle] = false;
      });
    },
  };
}

// Open the Inbox Chat when the page loads after a 3 second delay
// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(function () {
//     const observer = new IntersectionObserver(function (entries) {
//       entries.forEach(function (entry) {
//         if (entry.isIntersecting) {
//           if (window.ShopifyChat) {
//             const shadowRoot = ShopifyChat.shadowRoot;
//             const button = shadowRoot.querySelector("button");
//             if (button) {
//               button.click();
//             }
//           }
//           observer.disconnect();
//         }
//       });
//     });

//     const target = document.querySelector("body");
//     if (target) {
//       observer.observe(target);
//     }
//   }, 3000);
// });
